/**
 * Education Data
 * Contains academic history with courses and achievements
 */

import type { Education } from '@/types';
import { SUNYBuffaloLogo, VITLogo } from '../components/logos/EducationLogos';

export const education: Education[] = [
  {
    id: 1,
    degree: "Master of Science, Computer Science and Engineering",
    school: "University at Buffalo, The State University of New York",
    schoolLogo: SUNYBuffaloLogo,
    location: "Buffalo, NY",
    date: "Aug 2023 - Dec 2024",
    gpa: "3.833/4.0",
    details: [
      "Actively participated in ISI club",
      "Actively attended workshops on various topics like opencv, website hacking, kubernetes, clean-coding practices, etc.",
      "Relevant Courses: Analysis of Algorithms, Machine Learning, Computer Security, Deep Learning, Operating Systems"
    ],
    courses: ["Analysis of Algorithms", "Machine Learning", "Computer Security", "Deep Learning", "Operating Systems"]
  },
  {
    id: 2,
    degree: "Bachelor of Technology, Computer Science and Engineering",
    school: "Vellore Institute of Technology",
    schoolLogo: VITLogo,
    location: "Vellore, India",
    date: "June 2015 - Apr 2019",
    gpa: "",
    details: [
      "Actively organized and engaged in hackathons, promoting a collaborative environment",
      "Twice led the inter-hostel football team to semifinals, demonstrating leadership and teamwork",
      "Dedicated time to teaching underprivileged children with Ayuda, contributing to community",
      "Relevant Courses: Data Structures & Algorithms, Operating Systems, Computer Architecture, Machine Learning, IoT, C/ C++, Python, Discrete Mathematics, Linear Algebra, Probability and Statistics, SQL & NoSQL Database"
    ],
    courses: ["Data Structures & Algorithms", "Operating Systems", "Computer Architecture", "Machine Learning", "IoT", "C/C++", "Python", "Discrete Mathematics", "Linear Algebra", "Probability and Statistics", "SQL & NoSQL Database"]
  }
];

